import { QueryFactory } from "../../../../Common";
export const QGetCategories = QueryFactory("GetCategories");
//# sourceMappingURL=QGetCategories.js.map